export function buildTree(nodes) {
  const root = {};
  const nodeMap = {};
  nodes.forEach(node => {
    nodeMap[node.id] = node;
  });

  nodes.forEach(node => {
    if (!node?.path) return;
    const parts = node.path.split(",").filter(Boolean);
    let current = root;
    parts.forEach(part => {
      if (!current[part]) {
        current[part] = { __children: {}, __node: nodeMap[part] || null };
      }
      current = current[part].__children;
    });
    if (current[node.id]) {
      current[node.id].__node = node;
    } else {
      current[node.id] = { __children: {}, __node: node };
    }
  });
  return root;
}

export function treeToRows(tree, rows = [], productsMap = {}, prevNodeCode = null) {
  let lastCode = prevNodeCode;
  Object.values(tree).forEach(branch => {
    if (!branch.__node) {
      treeToRows(branch.__children, rows, productsMap, lastCode);
      return;
    }
    const nodeName = branch.__node.nodeText?.name || "";
    const nodeCode = branch.__node.code || "";
    const isPackageChange = lastCode !== null && lastCode !== nodeCode;

    rows.push({
      KOODI: nodeCode,
      "NIMIKKEEN KOODI": "",
      NIMI: nodeName,
      "NIMIKKEEN NIMI": "",
      MÄÄRÄ: isPackageChange ? 1 : "",
      YKSIKKÖ: isPackageChange ? "kpl" : ""
    });

    if (Array.isArray(branch.__node.items)) {
      branch.__node.items.forEach(item => {
        rows.push({
          KOODI: nodeCode,
          "NIMIKKEEN KOODI": item.code || "",
          NIMI: nodeName,
          "NIMIKKEEN NIMI": item.nodeText?.name ||
                productsMap[item.id]?.nodeText?.name ||
                item.name ||
                "",
          MÄÄRÄ: item.amount ?? "",
          YKSIKKÖ: item.unit || ""
        });
      });
    }
    treeToRows(branch.__children, rows, productsMap, nodeCode);
    lastCode = nodeCode;
  });
  return rows;
}